import { defineStore } from "pinia";
import api from "~/config/extensionsApi";
import { getApiAxios } from '~/helpers/index';
interface State {
  loyaltyData: any | null;
  loading: boolean;
  error: any | null;
}

export const useLoyaltyStore = defineStore("loyalty", {
  state: (): State => ({
    loyaltyData: null,
    loading: false,
    error: null,
  }),

  getters: {
    getLoyaltyData(state) {
      return state.loyaltyData;
    },
    isLoading(state) {
      return state.loading;
    },
    getError(state) {
      return state.error;
    },
  },

  actions: {
    async fetchLoyaltyDataStore() {
      this.loading = true;
      this.error = null;
      try {
        const { state } = this.$nuxt.app.context.$vsf.$magento.config;
        const userToken = state.getCustomerToken();
        const url = api.user.get_loyalty;
        const config = {
          headers: {
            Authorization: userToken,
          },
        };
        const response = await getApiAxios(url, config);
        this.loyaltyData = response;
      } catch (err) {
        this.error = new Error("Unexpected authorization error. Check your Network connection.");
      } finally {
        this.loading = false;
      }
    },
    resetLoyaltyDataStore() {
      this.loyaltyData = null;
    },
  },
});